import {
  NonInteractiveVisualizationWrapper,
  TitleSection,
} from '@mentimeter/question-modules-shared';
import { Box } from '@mentimeter/ragnar-ui/box';
import type {
  InteractiveCanvasComponents,
  PrioritisationT,
} from '@mentimeter/question-modules-types';
import type { Question } from '@mentimeter/http-clients';
import { PrioritisationVisualization } from './PrioritisationVisualization';

interface PrioritisationPresentationProps {
  question: Question;
  shouldAnimate: boolean;
  results: PrioritisationT['results'];
  CanvasVisualizationArea?: InteractiveCanvasComponents['CanvasVisualizationArea'];
}

export function PrioritisationPresentation({
  question,
  shouldAnimate,
  results,
  CanvasVisualizationArea,
}: PrioritisationPresentationProps) {
  const ConditionalWrapper =
    CanvasVisualizationArea ?? NonInteractiveVisualizationWrapper;

  return (
    <Box width="100%" height="100%" data-testid="100-points-container">
      <TitleSection
        question={question.question}
        questionStyled={question.question_styled}
        question_description={question.question_description}
        title_meta={question.title_meta}
        layout={question.layout}
        showTextSizeDropdown={true}
      />
      <ConditionalWrapper
        width="100%"
        height="100%"
        flex="1 1 auto"
        justifyContent="center"
        alignItems="center"
      >
        <PrioritisationVisualization
          question={question}
          shouldAnimate={shouldAnimate}
          results={results}
        />
      </ConditionalWrapper>
    </Box>
  );
}
